import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setInstallPrompt(e); setShowInstall(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);
  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const result = await installPrompt.userChoice;
    if (result.outcome === 'accepted') setShowInstall(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 100%)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        background: '#111827',
        border: '1px solid #1e2d45',
        borderRadius: 16,
        padding: 32
      }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 24 }}>
          <span style={{ fontSize: 32, fontWeight: 700, background: 'linear-gradient(135deg, #f59e0b, #fbbf24)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SM</span>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#94a3b8', letterSpacing: 3 }}>MEDIA</span>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>Selamat Datang</h1>
        <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28 }}>Login ke dashboard artis kamu</p>

        {/* 2026-10-26: setelah daftar, akun menunggu persetujuan admin */}
        {typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('registered') === 'true' && !error && (
          <div style={{ padding: '10px 12px', marginBottom: 14, borderRadius: 8, background: 'rgba(16,185,129,0.12)', color: '#059669', fontSize: 13, lineHeight: 1.5 }}>
            Pendaftaran diterima! Akun kamu sedang ditinjau admin. Kami akan mengirim email begitu akunnya aktif — setelah itu kamu bisa login.
          </div>
        )}
        {error && (
          <div style={{ background: '#450a0a', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="on">
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#94a3b8', marginBottom: 6 }}>Email</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="email@kamu.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
              style={{ fontSize: 16 }}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#94a3b8', marginBottom: 6 }}>Password</label>
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
              style={{ fontSize: 16 }}
            />
          </div>

          <div style={{ textAlign: 'right', marginBottom: 20 }}>
            <Link to="/forgot-password" style={{ color: '#f59e0b', fontSize: 13, textDecoration: 'none' }}>
              Lupa password?
            </Link>
          </div>

          <button
            type="submit"
            className="btn btn-gold"
            style={{ width: '100%', padding: 14, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Login'}
          </button>
        </form>

        {showInstall && (
          <div onClick={handleInstall} style={{display:'flex',alignItems:'center',gap:10,marginTop:20,padding:'12px 16px',background:'rgba(245,158,11,0.08)',border:'1px solid rgba(245,158,11,0.25)',borderRadius:10,cursor:'pointer'}}>
            <span style={{fontSize:22}}>📲</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#f59e0b'}}>Install SM Media App</div>
              <div style={{fontSize:11,color:'#64748b',marginTop:2}}>Tambahkan ke layar utama untuk akses lebih cepat</div>
            </div>
          </div>
        )}
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#94a3b8' }}>
          Belum punya akun? <Link to="/register" style={{ color: '#f59e0b', textDecoration: 'none', fontWeight: 500 }}>Daftar sekarang</Link>
        </p>
      </div>
    </div>
  );
}
